import Refiner from 'refiner-js';
import {useEffect} from 'react';
import serviceConfig from 'config';
import FeatureToggleUtils from 'FeatureToggleUtils';
import {ConsentCategory, onCategoryAllowed} from './consentHelper';

const refinerProjectId = serviceConfig.refinerProjectId;
const refinerSurveyWaitTime = Number(serviceConfig.refinerSurveyWaitTime) || 1200000; // default 20 minutes

const showForm = (surveyId) => {
    Refiner('showForm', surveyId);
};

const initializeRefiner = ({id, email, name}) => {
    Refiner('setProject', refinerProjectId);
    Refiner('identifyUser', {id, email, name});
};

const startRefinerSurveyTimer = (surveyId) => setTimeout(() => {
    showForm(surveyId);
}, refinerSurveyWaitTime);

const useRefinerSurvey = ({id, email, name, surveyId}) => {
    const shouldShowRefinerSurvey = FeatureToggleUtils.isFeatureEnabled('showRefinerSurvey');
    if (!shouldShowRefinerSurvey) {
        return;
    }

    useEffect(() => {
        let timeoutId;

        const removeListener = onCategoryAllowed(ConsentCategory.Functional, () => {
            initializeRefiner({id, email, name});
            timeoutId = startRefinerSurveyTimer(surveyId);
        });

        return () => {
            removeListener();
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);
};

export default useRefinerSurvey;
